import React from 'react';
import PropTypes from 'prop-types';
import keyBy from 'lodash/keyBy';
import { Box, Text } from 'roo-ui/components';
import { useModal } from 'lib/hooks';
import Modal from 'components/Modal';
import { ORDERED_INCLUSIONS_WHITELIST } from './constants';
import { ViewAllButton, Flag } from './primitives';
import InclusionsList from './InclusionsList';

const INCLUSIONS_PREVIEW_AMOUNT = 4;

const OfferInclusions = React.memo(({ inclusions }) => {
  const { openModal, modalProps } = useModal();
  const totalInclusions = inclusions.length;
  const showViewAll = totalInclusions > INCLUSIONS_PREVIEW_AMOUNT;
  const inclusionsByKey = keyBy(inclusions, 'code');

  const orderedInclusions = ORDERED_INCLUSIONS_WHITELIST.reduce((accum, { code, icon }) => {
    const inclusion = inclusionsByKey[code];
    if (!inclusion) return accum;
    return [...accum, { ...inclusion, icon }];
  }, []);

  const orderedInclusionsPreview = orderedInclusions.slice(0, INCLUSIONS_PREVIEW_AMOUNT);

  return (
    <Box color="greys.steel">
      <Box mt={3} data-testid="inclusions-preview-wrapper">
        {orderedInclusionsPreview.map((inclusion) => {
          const { code, icon, description } = inclusion;
          return (
            <Flag key={code} icon={icon}>
              <Text fontSize="base">{description}</Text>
            </Flag>
          );
        })}
      </Box>
      {showViewAll && (
        <ViewAllButton onClick={openModal} data-testid="view-all-inclusions">
          {`View ${totalInclusions} offer inclusions`}
        </ViewAllButton>
      )}
      <Modal {...modalProps} title="Offer Inclusions">
        <InclusionsList inclusions={orderedInclusions} />
      </Modal>
    </Box>
  );
});

OfferInclusions.defaultProps = {
  inclusions: [],
};

OfferInclusions.propTypes = {
  inclusions: PropTypes.array,
};

OfferInclusions.displayName = 'OfferInclusions';

export default OfferInclusions;
